import {
  List,
  Datagrid,
  TextField,
  DateField,
  ShowButton,
  EditButton,
  DeleteButton,
} from 'react-admin'

const CityList = (props) => {
  return (
    <List {...props}>
      <Datagrid>
        <TextField source='id' />
        <TextField source='name' />
        <TextField source='description' />
        <DateField source='createdAt' />
        <ShowButton basePath='/cities' />
        <EditButton basePath='/cities' />
        <DeleteButton basePath='/cities' mutationMode='optimistic' />
      </Datagrid>
    </List>
  )
}

export default CityList
